import requert from "@/utils/request"


export function userPhoneLogin(data) {
    return requert({
        url: '/expose/login/phone',
        method: 'post',
        data: data
    })
}